<!--
 * @Author: ymk
 * @Date: 2020-07-28 15:28:33
 * @LastEditors: ymk
 * @LastEditTime: 2020-07-28 19:08:48
 * @FilePath: \car-demo\src\views\Ranking\Instructor.vue
-->
<template>
  <div class="ranking">
    <FixedTool/>
    <nut-scroller
        v-if="listData && listData.length"
        class="wrapper"
        :is-un-more="isUnMore"
        :is-loading="isLoading"
        :type="'vertical'"
        :unloadMoreTxt="'—— 没有更多了 ——'"
        @loadMore="loadMoreVert"
        @pulldown="pulldown"
    >
      <div slot="list" class="nut-vert-list-panel">
        <div>
          <div @click="routerToDetail(item.id)"
              class="wrapper-item"
              v-for="(item, index) in listData"
              :key="index"
          >
            <InstructorItem :index="index" :borderBottom="true" :item="item">
              <template #desc>
                <li>教龄：{{ item.level_category }}年 | 学员：{{ item.fake_consult_count }}人</li>
                <li v-if="item.num>0">已收到{{item.num}}次打赏</li>
				        <li v-else>还未收到打赏</li>
              </template>
            </InstructorItem>
          </div>
        </div> 
      </div>
    </nut-scroller>
  
    <empty v-else class="wrapper"></empty>
    
  </div>
</template>

<script>
import InstructorItem from '@/components/InstructorItem' // 教练
import empty from '../Empty'


export default {
  name: 'ranking',
  components: {
    InstructorItem,
    empty
  },
  data: () => ({
    listData: [],
    isUnMore: false,
    isLoading: false,
    page: 1,
    pageSize: 15,//首次15条,以后每次10条
  }),
  created() {
    this.get_jlhrb();
  },
  methods: {
    get_jlhrb() {
      this.$ajax.get('m/gift/gift_ranking_by_sale_adviser', {
        activity_id: this.$ajax.get_activity_id(),
        page_size: this.pageSize,
        page: this.page
      }).then(res => {
        if (res.lists.length < this.pageSize) {
          this.isUnMore = true;
        }
        if ((res.lists && res.lists.length > 0) || this.listData.length > 0) {
          this.listData = this.listData.concat(res.lists);
          this.page++;
        } else {
          this.listData = [];
        }
        this.isLoading = false;
        this.pageSize = 10;
        // if (res && res.lists && res.lists.length) {
        //   this.listData = res.lists;
        //   this.isUnMore = false;
        //   this.page++;
        // } else {
        //   this.isUnMore = true;
        // }

      })
    },
    // 下拉加载更多
    pulldown() {
      this.isLoading = true;
      this.isUnMore = false;
      this.pageSize = 15;
      this.page = 1;
      this.listData = [];
      this.get_jlhrb();
    },
    // 上拉加载更多
    loadMoreVert() {
      this.isLoading = true;
      this.get_jlhrb();
    },
    /**
		 * 跳转教练详情
		 * @param {number} id - 教练id
		 */
		routerToDetail(coach_id) {
			this.$router.push({ name: 'CoachDetail', query: { coach_id: coach_id }});
		},
  },
}
</script>

<style lang="less" scoped>
.wrapper {
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  margin-top: 10px;
  margin-left: auto;
  margin-right: auto;
  width: 90vw;
  height: 90vh;
  padding: 10px;

  &-item {
    margin-bottom: 10px;
  }
}
</style>
